import(/* webpackMode: "eager" */ "/codebuild/output/src2767339906/src/faculdademetropolitana/src/app/(main)/layout.tsx");
